import firestore from "../firebase/firestore";

const clothesRef = firestore.collection("clothes");
const shoesRef = firestore.collection("shoes");

const getSizeRef = (type) => {
  if (type === "clothes") return clothesRef;
  if (type === "shoes") return shoesRef;
  throw new Error("Tipo de tamanho invalido.");
};

export const getSizes = (type) => getSizeRef(type);

export const getActiveClothes = () => clothesRef.where("active", "==", true);

export const getActiveShoes = () => shoesRef.where("active", "==", true);

export const createSize = (type, data) =>
  getSizeRef(type).add({
    ...data,
    active: true,
    created_at: new Date(),
    updated_at: new Date(),
  });

export const updateSize = (type, id, data) =>
  getSizeRef(type)
    .doc(id)
    .update({
      ...data,
      updated_at: new Date(),
    });

export const deleteSize = (type, id) =>
  updateSize(type, id, {
    active: false,
    deleted_at: new Date(),
  });
